import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { LocalService } from '../../_services/local.service';
import { CreateProfile } from '../account.model';

@Component({
  selector: 'app-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.scss']
})
export class CreateProfileComponent implements OnInit {
  model: any = {};
  public showError:boolean=false;
  public showExceptionError:boolean=false;
  email: string | null = null;
  public creatProfile: CreateProfile = new CreateProfile();
  public invalidUserName = false;
  constructor(private router: Router,
    private _loginService: LoginService,
    private _authenticationService: AuthenticationService,
    private _localService:LocalService,
    private route: ActivatedRoute) { 

      this.route.queryParams.subscribe(params => {
        this.creatProfile.Email = params['email'];
      });
    }

  ngOnInit() {

    this._loginService.verifyEmail(this.creatProfile).subscribe(
      response => {
        debugger
        const data = response["result"];
        this.creatProfile.UserId = data.Id;
         this.creatProfile.FirstName = data.FirstName;
         this.creatProfile.LastName = data.LastName;
         this.creatProfile.UserName = data.UserName;

      },
      err => {
        this.showExceptionError = true;
        console.log(err);

      }
    );
  }

  public attachDP(event) {
    debugger
    this.creatProfile.DPFile = event.target.files[0];
    this.creatProfile.DPFile.Name = "DP";
  }
  public onSubmit(){
debugger
  
    this._loginService.isValidUsername(this.creatProfile.UserName,this.creatProfile.UserId).subscribe(
      response => {
        debugger
        if(response == true){
            this.invalidUserName = true;
        }
        else{
          this._loginService.createProfile(this.creatProfile).subscribe(
            response => {
              debugger
              this.router.navigate(['account/login']);
            },
            err => {
              this.showExceptionError = true;
              console.log(err);
      
            }
          );
        }
      },
      err => {
        this.showExceptionError = true;
        console.log(err);

      }
    );

   
  }

}
